/**
 * Central palette for the module-level colours used everywhere in Le Desk
 * (Sidebar tiles, quick-action buttons, notification dots, dialog borders,
 * PerformanceIndex rings…).
 *
 * MODULE_COLORS — the single flat colour per module (used for chart accents,
 *   badges, quick-action buttons, etc.).
 * MODULE_GRADIENTS — the diagonal from/to pair rendered on the sidebar tiles
 *   and other feature icons. Values follow Hamza's brief:
 *     • Dashboard   : bleu   #1A8FE3 → #0A5A9E
 *     • Tâches      : jaune  #FBCB4A → #D99B1E
 *     • Documents   : bleu   #3568B0 → #1A3358
 *     • Calendrier  : violet #B478E8 → #7C3EAE
 *     • Validations : rose   #F472B6 → #C2317D
 *     • Accusés     : marron #B5713E → #7A4A24
 *     • Pointage    : teal   #4FBFA5 → #2A8570
 *
 * When a colour changes here, every consumer picks it up automatically —
 * please keep this file the single source of truth.
 */

export const MODULE_COLORS = {
  dashboard:   "#1A8FE3",
  tasks:       "#FBCB4A",
  documents:   "#3568B0",
  crm:         "#7C3AED",
  // Spec iter87 (Feb 2026) — passage rose magenta → violet MS Teams.
  // Primary sur fond sombre : #7b7fd4. Bouton plein : #5b5fc7. Carte
  // "TOTAL" sélectionnée / pilule fond : #252850. Cohérence garantie
  // sur toute l'app en modifiant ce fichier + AviIcon.jsx + les
  // références hardcodées #E85A9A / #C94A8A / #D1568A.
  validations: "#7b7fd4",
  accuses:     "#B5713E",
  pointage:    "#4FBFA5",
  tresorerie:  "#168570",
};

export const MODULE_GRADIENTS = {
  dashboard:   { from: "#1A8FE3", to: "#0A5A9E" },
  tasks:       { from: "#FBCB4A", to: "#D99B1E" },
  documents:   { from: "#3568B0", to: "#1A3358" },
  crm:         { from: "#7C3AED", to: "#4C1D95" },
  validations: { from: "#5b5fc7", to: "#252850" },
  accuses:     { from: "#B5713E", to: "#7A4A24" },
  pointage:    { from: "#4FBFA5", to: "#2A8570" },
  tresorerie:  { from: "#168570", to: "#168570" },
};

/** CSS `linear-gradient(...)` string ready to drop on a background. */
export const moduleGradient = (key, angle = 135) => {
  const g = MODULE_GRADIENTS[key];
  if (!g) return "transparent";
  return `linear-gradient(${angle}deg, ${g.from} 0%, ${g.to} 100%)`;
};

/**
 * Returns black or white depending on the luminance of the background hex.
 * Used to keep icons legible on top of a coloured tile / banner.
 */
export function contrastingIconColor(hex) {
  const c = hex.replace("#", "");
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? "#1B1B1B" : "#FFFFFF";
}
